import React from 'react';
import './HowToPlayModal.css';

/**
 * Shared “How to play” shell (Word Master overlay + modal styling).
 */
export function HowToPlayModal({ title, titleId, children, onClose, buttonText = 'Got it!' }) {
  return (
    <div
      className="how-to-play-overlay"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby={titleId}
    >
      <div className="how-to-play-modal" onClick={(e) => e.stopPropagation()}>
        <h2 id={titleId}>{title}</h2>
        {children}
        <button type="button" className="how-to-play-btn" onClick={onClose}>
          {buttonText}
        </button>
      </div>
    </div>
  );
}
